import { FC } from "react";

interface CalculatorStepIndicatorProps {
  step: string;
  label: string;
}

const CalculatorStepIndicator: FC<CalculatorStepIndicatorProps> = ({
  step = "1",
  label = "Label",
}) => {
  return (
    <div className="w-full flex gap-6 md:pb-8 pb-7  lg:pt-6 pt-4 items-center select-none">
      <div className="rounded-full bg-orange-light min-w-[40px] w-9 h-9 flex justify-center text-center items-center text-white font-bold">
        <span>{step}</span>
      </div>
      <div className="flex justify-center items-center text-left md:text-4xl text-3xl">
        {label}
      </div>
    </div>
  );
};

export default CalculatorStepIndicator;
